"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                DocumentViewer_AddButtonLabel: "Add",
                DocumentViewer_AttachmentsButtonLabel: "Attachments",
                DocumentViewer_ConfirmDelete: "Are you sure you want to delete the attached document?",
                DocumentViewer_DeleteButtonLabel: "Delete",
                DocumentViewer_EmptyAddButtonLabel: "Upload",
                DocumentViewer_EmptyDocuRefText: "No document to preview",
                DocumentViewer_EmptyText: "Nothing to show",
                DocumentViewer_FailedDelete: "Failed to delete document",
                DocumentViewer_NoPreviewDateLabel: "Date",
                DocumentViewer_NoPreviewExpandedText: "The attached document cannot be previewed. The document might use an unsupported file type or the connection with the Office Web App has failed. Open the document locally to view it.",
                DocumentViewer_NoPreviewFileNameLabel: "File name",
                DocumentViewer_NoPreviewText: "No preview available",
                DocumentViewer_NoRecordText: "No record found",
                DocumentViewer_OpenButtonLabel: "Open",
            },
        });
        var DocumentViewer = /** @class */ (function (_super) {
            __extends(DocumentViewer, _super);
            function DocumentViewer(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /** Handler for when the attachments button is clicked; shows the attachments flyout. */
                _this.AttachmentsButtonClicked = function () {
                    var flyOut = _this.RootControl.find(DocumentViewer.FlyoutSelector);
                    var toolBar = _this.RootControl.find(DocumentViewer.ToolBarSelector);
                    if (flyOut.is(":visible")) {
                        flyOut.hide();
                    }
                    else {
                        flyOut.css("left", toolBar.position().left + "px");
                        flyOut.css("top", (toolBar.position().top + toolBar.height()).toString() + "px");
                        flyOut.css("width", _this.RootControl.width().toString() + "px");
                        flyOut.show();
                    }
                };
                /** Closes the documents viewer flyout. */
                _this.CloseDocumentsViewerFlyout = function () {
                    _this.RootControl.find(DocumentViewer.FlyoutSelector).hide();
                };
                /**
                 * Handler for when an attachments flyout option is clicked; performs logic to select the new document
                 * @param event The click event.
                 */
                _this.DocumentViewerFlyoutOptionClicked = function (event) {
                    var selectedDocumentClass = "documentViewerSelectedDocument";
                    var docuValueRecIdAttribute = "docu-value-rec-id";
                    var currentElement = $(event.currentTarget);
                    var selectedElement = _this.RootControl.find("li[" + docuValueRecIdAttribute + "=\"" + $dyn.value(_this.SelectedDocument).DocuValueRecId + "\"]");
                    // Apply selected document class appropriately to clicked element
                    selectedElement.removeClass(selectedDocumentClass);
                    currentElement.addClass(selectedDocumentClass);
                    // Select the clicked element
                    var targetRecId = currentElement.attr(docuValueRecIdAttribute);
                    _this.SelectDocument(targetRecId);
                    // Update the viewer for the newly selected document
                    _this.CloseDocumentsViewerFlyout();
                };
                /** Handler for when the download button is clicked. */
                _this.DownloadDocumentClicked = function () {
                    $dyn.shell.navigateUrl({ openInNewTab: false, url: $dyn.value(_this.SelectedDocument).DownloadUrl });
                };
                /** Handler for when the delete button is clicked. */
                _this.DeleteDocumentClicked = function () {
                    // If delete is disabled, don't allow the document to be deleted
                    if (!_this.AllowDelete) {
                        return;
                    }
                    var confirmMessage = $dyn.label("DocumentViewer_ConfirmDelete");
                    var messageAction = function (btn) {
                        if (btn === $dyn.controls.MessageBox.Button.Yes) {
                            $dyn.async.pending.increment("Delete document from viewer init");
                            $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("DocumentViewer_ConfirmDelete");
                            $.ajax({
                                beforeSend: function (request) {
                                    $dyn.serverForm.setCsrfToken(request);
                                    request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax();
                                },
                                complete: _this.PerformDelete,
                                type: "DELETE",
                                url: $dyn.value(_this.SelectedDocument).DownloadUrl,
                            });
                        }
                    };
                    $dyn.showMessageBox({ Text: confirmMessage, showYesButton: true, showNoButton: true, callback: messageAction });
                };
                /**
                 * Call back function for when a deletion occurs; updates the UI to remove the deleted document or shows an error.
                 * @param request The sent request.
                 * @param textStatus The text status corresponding to the response.
                 */
                _this.PerformDelete = function (request, textStatus) {
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                    // If successful deletion, update the UI and remove the document from the list of documents
                    if (textStatus === "success") {
                        var documents = $dyn.value(_this.Documents).slice(0);
                        var selectedIndex = documents.indexOf($dyn.value(_this.SelectedDocument));
                        if (selectedIndex !== -1) {
                            documents.splice(selectedIndex, 1);
                            var recIdSelection = void 0;
                            if (documents.length > 0) {
                                if (selectedIndex === documents.length) {
                                    recIdSelection = selectedIndex - 1;
                                }
                                else {
                                    recIdSelection = selectedIndex;
                                }
                            }
                            var doc = void 0;
                            if (recIdSelection || recIdSelection === 0) {
                                doc = documents[recIdSelection];
                                doc.Selected = 1;
                            }
                            $dyn.setValue(_this, "SelectedDocument", doc);
                            $dyn.setValue(_this, "Documents", documents);
                        }
                    }
                    else {
                        var msg = $dyn.label("DocumentViewer_FailedDelete");
                        if (request) {
                            try {
                                var r = JSON.parse(request.responseText);
                                if (r && r.ErrorMessage) {
                                    msg = r.ErrorMessage;
                                }
                            }
                            catch (e) { /* no-op */ }
                        }
                        $dyn.error({ Message: msg, Label: "DocumentViewer_FailedDelete" }, _this);
                    }
                    // Done with loading, so decrement loading counter
                    $dyn.async.pending.decrement("Delete document from viewer complete");
                };
                $dyn.setValue(_this, "LayoutHeight", $dyn.value(_this.Height) || $dyn.layout.Size.content);
                $dyn.setValue(_this, "LayoutWidth", $dyn.value(_this.Width) || $dyn.layout.Size.content);
                _this.RootControl = $(element);
                _this.NumberOfDocuments = $dyn.observable(0);
                _this.HasRecord = $dyn.observable(false);
                _this.SelectedDocument = $dyn.observable(null);
                _this.MaxPreviewHeight = 0;
                _this.MaxPreviewWidth = 0;
                _this.HasDocuments = $dyn.computed(function () { return $dyn.value(_this.NumberOfDocuments) > 0; });
                _this.ViewerEmpty = $dyn.computed(function () { return !$dyn.value(_this.HasDocuments); });
                _this.ButtonsEnabled = $dyn.computed(function () {
                    var referencesDocuRefTable = $dyn.value(_this.ReferencesDocuRef);
                    return $dyn.value(_this.HasRecord) && (referencesDocuRefTable === 0);
                });
                _this.EmptyViewerAddButtonVisible = $dyn.computed(function () { return $dyn.value(_this.ButtonsEnabled) && $dyn.value(_this.AllowUpload); });
                _this.EmptyViewerLabelVisible = $dyn.computed(function () { return !$dyn.value(_this.EmptyViewerAddButtonVisible); });
                _this.EmptyViewerLabel = $dyn.computed(function () {
                    var retLabel;
                    if ($dyn.value(_this.HasRecord)) {
                        if ($dyn.value(_this.ReferencesDocuRef) === 0) {
                            retLabel = "DocumentViewer_EmptyText";
                        }
                        else {
                            retLabel = "DocumentViewer_EmptyDocuRefText";
                        }
                    }
                    else {
                        retLabel = "DocumentViewer_NoRecordText";
                    }
                    return $dyn.label(retLabel);
                });
                _this.ToolBarShown = $dyn.computed(function () { return $dyn.value(_this.ButtonsEnabled) && $dyn.value(_this.HasDocuments); });
                _this.AttachmentsButtonShown = $dyn.computed(function () { return $dyn.value(_this.NumberOfDocuments) > 1; });
                _this.HasDocumentPreview = $dyn.computed(function () {
                    var doc = $dyn.value(_this.SelectedDocument);
                    return doc && doc.DocumentUrl && doc.DocumentUrl.length > 0;
                });
                _this.HasDocumentNoPreview = $dyn.computed(function () {
                    var doc = $dyn.value(_this.SelectedDocument);
                    return doc && !(doc.DocumentUrl && doc.DocumentUrl.length > 0);
                });
                _this.PreviewSrcUrl = $dyn.computed(function () {
                    var url;
                    if ($dyn.value(_this.HasDocumentPreview)) {
                        url = $dyn.value(_this.SelectedDocument).DocumentUrl;
                    }
                    else {
                        url = "";
                    }
                    return url;
                });
                _this.PreviewSrcThumbnail = $dyn.computed(function () {
                    var url;
                    if ($dyn.value(_this.HasDocumentNoPreview)) {
                        url = $dyn.value(_this.SelectedDocument).ThumbnailImageUrl;
                    }
                    else {
                        url = "";
                    }
                    return url;
                });
                _this.PreviewDocumentName = $dyn.computed(function () {
                    var name;
                    if ($dyn.value(_this.HasDocumentNoPreview)) {
                        name = $dyn.value(_this.SelectedDocument).Name;
                    }
                    else {
                        name = "";
                    }
                    return name;
                });
                _this.PreviewDate = $dyn.computed(function () {
                    var lastModified;
                    if ($dyn.value(_this.HasDocumentNoPreview)) {
                        lastModified = $dyn.value(_this.SelectedDocument).FriendlyLastModified;
                    }
                    else {
                        lastModified = "";
                    }
                    return lastModified;
                });
                // Observe the referenced RecId, to call the appropriate command to update the list of documents when changed
                $dyn.observe(_this.ReferenceValueRecId, function (recId) {
                    // This is done to allow other javascript to continue executing
                    $dyn.async(function () {
                        $dyn.getFunction(_this.ReferencedRecordChange)();
                    }, undefined, "Referenced record change");
                    var hasRec = false;
                    // tslint:disable-next-line: triple-equals
                    if (recId && recId != 0) {
                        hasRec = true;
                    }
                    else {
                        $dyn.setValue(_this, "SelectedDocument", null);
                    }
                    $dyn.setValue(_this, "HasRecord", hasRec);
                    $dyn.setValue(_this, "HasNoRecord", !hasRec);
                });
                // Observe the documents, to update the UI when the documents change
                $dyn.observe(_this.Documents, function (docs) {
                    var docsLength;
                    if (docs) {
                        docsLength = docs.length;
                    }
                    else {
                        docsLength = 0;
                    }
                    $dyn.setValue(_this, "NumberOfDocuments", docsLength);
                    if (docs != null && docsLength > 0) {
                        _this.SelectDocument();
                    }
                    else {
                        $dyn.setValue(_this, "SelectedDocument", null);
                    }
                });
                // Observe the preview source URL and render the new content.
                // Note: we have to replace the iframe instead of binding to the src attribute in the template to avoid unwanted navigation events.
                $dyn.observe(_this.PreviewSrcUrl, function (newVal) {
                    // default to sandboxing the preview's iframe
                    var sandbox = "sandbox=''";
                    var previewCode = "";
                    var doc = $dyn.value(_this.SelectedDocument);
                    var previewDiv = $(element).find("div.documentViewerPreview");
                    var isWopi = false;
                    var wopiFormId = $dyn.value(_this.Id) + "_wopi";
                    if (doc) {
                        if (doc.MimeType && doc.MimeType.lastIndexOf("image/", 0) === 0) {
                            _this.calculatePreviewSize();
                            previewCode = $dyn.format("<img src='{0}' alt='{1}' style='max-height: {2}px; max-width: {3}px'></img>", newVal, doc.Name, _this.MaxPreviewHeight, _this.MaxPreviewWidth);
                        }
                        if (doc.TrustedSource) {
                            // do not sandbox the iframe is the document source is trusted
                            sandbox = "";
                            // WOPI requires the iframe to be created via a POST
                            if (doc.WopiActionUrl) {
                                isWopi = true;
                            }
                        }
                        if (!previewCode) {
                            if (!isWopi) {
                                previewCode = $dyn.format("<iframe src='{0}' {1}></iframe>", newVal, sandbox);
                            }
                            else {
                                // Add the form used to post the WOPI access token in addition to the target iframe
                                // WOPI frames are always for a trusted source
                                previewCode = $dyn.format("<form id='{0}' name='{0}' target='{0}_frame' action='{1}' method='post'>" +
                                    "<input name='access_token' value='{2}' type='hidden'/>" +
                                    "<input name='access_token_ttl' value='{3}' type='hidden'/>" +
                                    "</form>" +
                                    "<iframe id='{0}_frame' name='{0}_frame'></iframe>", wopiFormId, doc.WopiActionUrl, doc.WopiAccessToken, doc.WopiAccessTokenTtl);
                            }
                        }
                    }
                    // Empty the previewer div
                    previewDiv.children().remove();
                    previewDiv.append(previewCode);
                    if (isWopi) {
                        $(previewDiv).find("form").submit();
                    }
                });
                if (_this.Root) {
                    $dyn.observe(_this.Root.Refreshing, function (newVal) {
                        if (newVal) {
                            $dyn.getFunction(_this.ReferencedRecordChange)();
                        }
                    });
                }
                return _this;
            }
            /**
             * Set the selected document from the currently selected document in the list of documents
             * @param recId The record ID
             */
            DocumentViewer.prototype.SelectDocument = function (recId) {
                var e_1, _a;
                var docs = $dyn.value(this.Documents);
                try {
                    for (var docs_1 = __values(docs), docs_1_1 = docs_1.next(); !docs_1_1.done; docs_1_1 = docs_1.next()) {
                        var doc = docs_1_1.value;
                        // If a RecId was given, then set only the record matching the RecId as selected, and
                        // set all other records as not selected
                        if (recId) {
                            // tslint:disable-next-line:triple-equals
                            if (doc.DocuValueRecId == recId) {
                                doc.Selected = 1;
                            }
                            else {
                                doc.Selected = 0;
                            }
                        }
                        if (doc.Selected === 1) {
                            $dyn.setValue(this, "SelectedDocument", doc);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (docs_1_1 && !docs_1_1.done && (_a = docs_1.return)) _a.call(docs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            };
            DocumentViewer.prototype.calculatePreviewSize = function () {
                if (this.MaxPreviewHeight === 0 || this.MaxPreviewWidth === 0) {
                    var iframeElement = $(this.element).find("div.documentViewerPreview iframe");
                    var sizingElement = void 0;
                    var tempEl = void 0;
                    var height = 0;
                    var width = 0;
                    if (iframeElement.is(":visible")) {
                        sizingElement = iframeElement;
                    }
                    else {
                        // look for the next element which, if present, has been used for preview purposes.
                        tempEl = iframeElement.next();
                        if (tempEl.length > 0) {
                            // use the previous setting if available
                            // tslint:disable-next-line:radix
                            height = parseInt(tempEl.css("max-height"));
                            // tslint:disable-next-line:radix
                            width = parseInt(tempEl.css("max-width"));
                            sizingElement = tempEl;
                        }
                        else {
                            sizingElement = $(this.element);
                            if ($dyn.value(this.ToolBarShown)) {
                                var toolbar_1 = $(this.element).find(DocumentViewer.ToolBarSelector);
                                if (toolbar_1.is(":visible")) {
                                    height -= toolbar_1.height();
                                }
                            }
                        }
                    }
                    if (height === 0 || width === 0) {
                        height = sizingElement.height();
                        width = sizingElement.width();
                    }
                    this.MaxPreviewHeight = height;
                    this.MaxPreviewWidth = width;
                }
            };
            DocumentViewer.ToolBarSelector = ".documentViewerToolBar";
            DocumentViewer.FlyoutSelector = ".documentViewerFlyOutDiv";
            return DocumentViewer;
        }($dyn.ui.Control));
        controls.DocumentViewer = DocumentViewer;
        DocumentViewer.prototype.ReferencesDocuRef = 0;
        DocumentViewer.prototype.ReferenceValueRecId = null;
        DocumentViewer.prototype.Documents = null;
        DocumentViewer.prototype.AllowDelete = true;
        DocumentViewer.prototype.AllowUpload = true;
        DocumentViewer.prototype.ReferencedRecordChange = null;
        DocumentViewer.prototype.AddNewDocument = null;
        $dyn.ui.addPropertiesToPrototype(DocumentViewer.prototype, {
            LayoutHeight: { defaultValue: $dyn.layout.Size.content, observable: true },
            LayoutWidth: { defaultValue: $dyn.layout.Size.content, observable: true },
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DocumentViewer.js.map
